'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createEagerFactory = require('recompose/createEagerFactory');

var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);

var _omit = require('lodash/fp/omit');

var _omit2 = _interopRequireDefault(_omit);

var _pick = require('lodash/fp/pick');

var _pick2 = _interopRequireDefault(_pick);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function toArray(set) {
  return Array.from(set.values());
}
function createScope(props) {
  var consumingKeys = new Set();
  var exposingKeys = new Set();

  var consumeKeys = null;
  var exposeKeys = null;
  return {
    outerProps: props,
    // bind `add` to owner Set in advance for passing it as callback
    // `addToConsuming: consumingKeys.add` does not bind add, will cause error
    addToConsuming: function addToConsuming(v) {
      return consumingKeys.add(v);
    },
    addToExposing: function addToExposing(v) {
      return exposingKeys.add(v);
    },
    namespace: null,
    consume: function consume(outerProps) {
      if (!consumeKeys) consumeKeys = (0, _omit2.default)(toArray(consumingKeys));
      return consumeKeys(outerProps);
    },
    expose: function expose(innerProps) {
      if (!exposeKeys) exposeKeys = (0, _pick2.default)(toArray(exposingKeys));
      return exposeKeys(innerProps);
    },

    notifyOutBound: null
  };
}

var enterScope = function enterScope(BaseComponent) {
  var factory = (0, _createEagerFactory2.default)(BaseComponent);

  var ProvideScope = function (_React$Component) {
    _inherits(ProvideScope, _React$Component);

    function ProvideScope(props, context) {
      _classCallCheck(this, ProvideScope);

      var _this = _possibleConstructorReturn(this, (ProvideScope.__proto__ || Object.getPrototypeOf(ProvideScope)).call(this, props, context));

      _this.scope = createScope(_this.props);
      return _this;
    }

    _createClass(ProvideScope, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        this.scope.outerProps = nextProps;
        if (this.scope.notifyOutBound) this.scope.notifyOutBound();
      }
    }, {
      key: 'getChildContext',
      value: function getChildContext() {
        return _defineProperty({}, _utils.SCOPE, (this.context[_utils.SCOPE] || []).concat(this.scope));
      }
    }, {
      key: 'render',
      value: function render() {
        return factory({}); // intent to omit all outer props
      }
    }]);

    return ProvideScope;
  }(_react2.default.Component);

  ProvideScope.contextTypes = _utils.scopeContextTypes;
  ProvideScope.childContextTypes = _utils.scopeContextTypes;

  return ProvideScope;
};

exports.default = enterScope;


//////////////////
// WEBPACK FOOTER
// ./~/recompose-scope/enterScope.js
// module id = 511
// module chunks = 0